// @ts-nocheck
// 0003375-72.2019.2.00.0000
// 5010771-02.2020.4.04.0000
import { inject } from '@angular/core';
import { Validate } from 'validate-cnj';
import { ASSETS } from '../../../assets/assets';
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskCnj {
  public insertIconValidate = true;

  public validateAllDigit = false;
  public maxLength = 20;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);

    if (newValue.length > 20) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }

    return { newValue, newCursorPosition };
  }

  public setMask(
    value: string | null | number,
    cursorPosition
  ): { formatedValue; formatedCursorPosition } | null {
    try {
      if (!value) return null;
      const param = typeof value === 'number' ? String(value) : value;
      if (param.length <= 8) {
        const formatedValue = param.replace(/^(\d{1,7})(\d{1})$/, '$1-$2');
        const formatedCursorPosition =
          cursorPosition < param.length - 1 ? cursorPosition : cursorPosition + 1;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (param.length <= 10) {
        const formatedValue = param.replace(/^(\d{7})(\d{1,2})(\d{1})/, '$1-$2.$3');

        let formatedCursorPosition = cursorPosition;
        if (cursorPosition >= 8) formatedCursorPosition++;
        if (cursorPosition >= 9) formatedCursorPosition++;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (param.length <= 14) {
        const formatedValue = param.replace(/^(\d{7})(\d{2})(\d{1,4})(\d{1})/, '$1-$2.$3.$4');

        let formatedCursorPosition = cursorPosition;
        if (cursorPosition >= 8) formatedCursorPosition++;
        if (cursorPosition >= 9) formatedCursorPosition++;
        if (cursorPosition >= 11) formatedCursorPosition++;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (param.length <= 15) {
        const formatedValue = param.replace(
          /^(\d{7})(\d{2})(\d{4})(\d{1})(\d{1})/,
          '$1-$2.$3.$4.$5'
        );

        let formatedCursorPosition = cursorPosition;
        if (cursorPosition >= 8) formatedCursorPosition++;
        if (cursorPosition >= 9) formatedCursorPosition++;
        if (cursorPosition >= 11) formatedCursorPosition++;
        if (cursorPosition >= 12) formatedCursorPosition++;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (param.length <= 17) {
        const formatedValue = param.replace(
          /^(\d{7})(\d{2})(\d{4})(\d{1})(\d{1,2})(\d{1})/,
          '$1-$2.$3.$4.$5.$6'
        );

        let formatedCursorPosition = cursorPosition;
        if (cursorPosition >= 8) formatedCursorPosition++;
        if (cursorPosition >= 9) formatedCursorPosition++;
        if (cursorPosition >= 11) formatedCursorPosition++;
        if (cursorPosition >= 12) formatedCursorPosition++;
        if (cursorPosition >= 14) formatedCursorPosition++;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else {
        const formatedValue = param.replace(
          /^(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{1,4})(\d{1})/,
          '$1-$2.$3.$4.$5.$6$7'
        );

        let formatedCursorPosition = cursorPosition;
        if (cursorPosition >= 8) formatedCursorPosition++;
        if (cursorPosition >= 9) formatedCursorPosition++;
        if (cursorPosition >= 11) formatedCursorPosition++;
        if (cursorPosition >= 12) formatedCursorPosition++;
        if (cursorPosition >= 14) formatedCursorPosition++;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      }
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  public validate(value) {
    // if (value.length !== 20) return false;
    try {
      Validate.load(value);
      return true;
    } catch {
      return false;
    }
  }

  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['CNJ']];
  }
}

export class InjectableMaskCnj extends MaskCnj {
  constructor(public assets = inject(ASSETS)) {
    super(null, assets);
  }
}
